import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from './config'

const uploadFile = (file, filePath) => {
    //console.log(filePath);
    return new Promise(async(resolve, reject) => {
        const storageRef = ref(storage, filePath);
        //console.log(storageRef);
        try {
            await uploadBytes(storageRef, file);
            const url = await getDownloadURL(storageRef);
            //console.log(url);
            resolve(url);
        } catch (error) {
            //console.log('rejected');
            reject(error);
        }
    })
}

export default uploadFile;